function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKlaviyo = function SvgKlaviyo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M56.583 48.797H4V12h52.583L45.544 30.399l11.038 18.398Z",
    fill: props.color,
    stroke: props.color
  }));
};
export default SvgKlaviyo;